import { render, staticRenderFns } from "./SCR.vue?vue&type=template&id=37853c48"
import script from "./SCR.vue?vue&type=script&lang=js"
export * from "./SCR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports